import md from '@/routes/middlewares';

import Services from '@/views/Services.vue';

import WorkOrders from '@/views/workOrders/WorkOrders.vue';
import WorkOrdersTemplate from '@/views/workOrders/template/WorkOrdersTemplate.vue';
import FieldServiceBilling from '@/views/billing/fieldServiceBilling.vue';
import billingLaboratory from '@/views/billing/billingLaboratory.vue';
import SectionTemplate from '@/views/workOrders/template/SectionTemplate.vue';

const services = {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {
        middlewares: [
            md.auth,
            md.accessControl,
        ],
    },
    redirect: { name: 'serviceWorkOrders' },
    children: [
        {
            path: 'serviceWorkOrders',
            name: 'serviceWorkOrders',
            component: WorkOrders,
        },
        {
            path: 'workOrdersTemplate',
            name: 'workOrdersTemplate',
            component: WorkOrdersTemplate,
        },
        {
            path: 'workOrdersTemplate/createTemplate',
            name: 'createTemplate',
            component: SectionTemplate,
        },
        {
            path: 'workOrdersTemplate/:woTemplateId',
            redirect: { name: 'editTemplate' },
            component: SectionTemplate,
            meta: {
                middlewares: [
                    md.getWOTemplateInfo,
                ],
            },
            children: [
                {
                    path: 'editTemplate',
                    name: 'editTemplate',
                },
            ],
        },
        {
            path: 'assignations',
            name: 'assignations',
        },
        {
            path: 'fieldServicebilling',
            name: 'fieldServicebilling',
            component: FieldServiceBilling,
        },
        {
            path: 'billingLaboratory',
            name: 'billingLaboratory',
            component: billingLaboratory,
        },
    ],
};

export default services;
